import { render, staticRenderFns } from "./tiktok.vue?vue&type=template&id=265bbf3f&"
import script from "./tiktok.vue?vue&type=script&lang=js&"
export * from "./tiktok.vue?vue&type=script&lang=js&"
import style0 from "./tiktok.vue?vue&type=style&index=0&id=265bbf3f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports